import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import { ActionModalSchema, Context, Transitions } from "../../types"
import { saveCancelModalState } from "../manageModals"

export const massDeleteModalState: StateNodeConfig<
  Context,
  ActionModalSchema,
  Transitions,
  BaseActionObject
> = {
  entry: assign<Context>({ openMassDeleteModal: true }),
  exit: assign<Context>({ openMassDeleteModal: false }),
  ...saveCancelModalState(
    "#ManageUserModules.classes_page.loading",
    "massDeleteClasses",
    {
      cancelTarget: "#ManageUserModules.classes_page.idle",
      loadingState: "remove",
      onSuccess: (ctx, evt) => ({
        snackbar: {
          message: evt.data
            ? `Successfully deleted ${evt.data} of ${ctx.massSelectClassRecordIds.length} classes`
            : "Unable to delete classes",
          withUndo: false,
          error: !evt.data
        },
        massSelectClassRecordIds: []
      }),
      onError: (ctx, _evt) => ({
        snackbar: {
          message: `An error occurred. Unable to delete ${ctx.snackbarMessageInfo} classes`,
          withUndo: false,
          error: true
        }
      })
    }
  )
}
